import { Injectable } from '@kaokei/use-vue-service';
import { DaoService } from './dao.service';

import { UserCreationActivityType, UserCreationList } from '@/types';

@Injectable()
export class UserCreationService {
  public activityType = 1; // 默认是NOC
  public activityId = 1; // 暂时不支持查询特定活动的优秀作品
  public contestItem!: number; // 暂时不支持赛项查询
  public contestScheduleId!: number; // 暂时不支持组别查询
  public userName!: string; // 暂时不支持用户名搜索

  public pageNum = 1;
  public pageSize = 12;
  public total = 0;

  public userCreationList: UserCreationList = [];
  public activityTypeList: Array<UserCreationActivityType> = [];

  constructor(public daoService: DaoService) {}

  public setActivityType(type: number) {
    this.activityType = type;
  }

  public setPageNum(num: number) {
    this.pageNum = num;
  }

  public setPageSize(size: number) {
    this.pageSize = size;
  }

  public search() {
    window.scrollTo(0, 0);
    return this.daoService
      .getUserCreationList(this.pageNum, this.pageSize, this.activityType)
      .then(res => {
        this.userCreationList = res.list;
        this.total = res.total;
      });
  }

  public resetSearch() {
    this.setPageNum(1);
    this.setPageSize(12);
    this.search();
  }

  public getActivityTypeList() {
    return this.daoService.getUserCreationActivityType().then(res => {
      this.activityTypeList = res.filter(item => [1, 3].includes(item.code));
      if (res && res.length) {
        this.setActivityType(res[0].code);
      }
    });
  }
}
